import React from 'react';
import { Col, Layout, Row } from 'antd';
import classNames from 'classnames';
import get from 'lodash/get';
import { connect } from 'react-redux';

import Footer from "../../components/Footer/Footer";
import ConsentForm from "../../components/ConsentTypeWinnipeg/ConsentForm";

import {consentServices} from "../../services";

import { getConsentData } from "../../reducers/consent/selectors";
import { consentUpdate } from "../../reducers/consent/actions";

import classes from "./ConsentTypeWinnipeg.css";

const { Content } = Layout;

class Consent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      step: {}
    };
  }

  async componentDidMount() {
    const token = get(this.props, 'match.params.token');

    if (this.props.consentData) {
      this.setState({ step: { ...this.props.consentData } });
      this.props.consentUpdate({});
    } else if (token) {
      try {
        const { data } = await consentServices.getConsentWinnipegByToken(token);
        const step = {
          consentMethodType: get(data, 'consentExistsMethodType'),
          consentPersonType: get(data, 'consentExistsPersonType'),
          subjectID: get(data, 'subjectID'),
          consentDate: get(data, 'consentDate'),
          wp_participant_email: get(data, 'details.wp_participant_email') || undefined,
          wp_consent_participant_name: get(data, 'details.wp_consent_participant_name') || undefined,
          wp_consent_guardian_name: get(data, 'details.wp_consent_guardian_name') || undefined,
          wp_consent_investigator_name: get(data, 'details.wp_consent_investigator_name') || undefined,
          wp_consent_investigator_role: get(data, 'details.wp_consent_investigator_role') || undefined,
          wp_rccf_consent_participant_name: get(data, 'details.wp_rccf_consent_participant_name') || undefined,
          wp_rccf_consent_guardian_name: get(data, 'details.wp_rccf_consent_guardian_name') || undefined,
          wp_rccf_consent_investigator_name: get(data, 'details.wp_rccf_consent_investigator_name') || undefined,
          wp_rccf_consent_investigator_role: get(data, 'details.wp_rccf_consent_investigator_role') || undefined,
        };
        this.setState({ step, currentStepPerson: get(data, 'consentExistsPersonType') });
      } catch (e) {
        this.props.history.push('/consent_error');
      }
    } else {
      this.props.history.push('/consent');
    }
  }

  render() {
    const token = get(this.props, 'match.params.token');
    const { step: { consentMethodType, consentPersonType }} = this.state;

    return (
      <div style={{ backgroundColor: '#FAFAFA' }}>
        <Layout className={classes.parentContainer}>
          <Content className={classes.content}>
            <Row>
              <Col xs={{ span: 24 }} sm={{ span: 20, offset: 2 }} md={{ span: 16, offset: 4 }} style={{ paddingTop: '4rem' }}>
                <h1 ><span style={{ color: '#286DA8' }}>AcT</span></h1>

                <Row type='flex' justify='center'>
                  <Col className={classNames(classes.contentWrap, 'frosted-card-edm')}  xs={24} sm={18} md={18} lg={20} xl={22}>
                    {(!token || (token && consentMethodType && consentPersonType)) &&
                      <ConsentForm token={token} step={{...this.state.step}} currentStepPerson={this.state.currentStepPerson} history={this.props.history}/>
                    }
                  </Col>
                </Row>
              </Col>
            </Row>
          </Content>
          <Footer />
        </Layout>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  consentData: getConsentData(state),
});

const mapDispatchToProps = { consentUpdate };

export default connect(mapStateToProps, mapDispatchToProps)(Consent);



// WEBPACK FOOTER //
// ./src/containers/ConsentTypeWinnipeg/ConsentTypeWinnipeg.js